function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0H1440V1024H0z",
  transform: "translate(-511 -413)"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_f)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#6A7595",
  fillOpacity: 0.26,
  d: "M98 210h223v76l-128 48.5L98 286v-76z"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#B2B9CB",
  fillRule: "evenodd",
  d: "M222.945 91.907l88.306 39.348-113.626 32.848-89.579-43.415 114.899-28.78z",
  clipRule: "evenodd"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C2",
  fillRule: "evenodd",
  d: "M222.945 91.907V212.55l87.804 34.356.523-114.899-88.327-40.099z",
  clipRule: "evenodd"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M310.749 246.905l-113.33 38.291-.238-121.473 114.091-31.717-.523 114.899z",
  clipRule: "evenodd"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M108.283 120.921v112.557l89.136 51.718V163.723l-89.136-42.802z",
  clipRule: "evenodd"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M108.489 121.3l114.456-29.392-24.131-27.252-113.6 26.914 23.275 29.73zM222.945 91.907l19.636-27.252 89.336 38.688-20.645 28.663-88.327-40.099z",
  clipRule: "evenodd"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#B2B9CB",
  fillRule: "evenodd",
  d: "M108.262 122.384L85.214 91.57l90.715 38.194 21.464 33.894-89.131-41.274zM197.472 163.695l22.541-33.104 111.904-27.248-20.645 28.663-113.8 31.689z",
  clipRule: "evenodd"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M197.181 163.723l22.832-33.133 1.812 1.691-24.644 31.442z",
  clipRule: "evenodd"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C2",
  fillRule: "evenodd",
  d: "M220.013 130.591l1.812 1.691 109.115-27.539.977-1.4-111.904 27.248z",
  clipRule: "evenodd"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M197.625 164.103l-21.696-34.339-1.844 1.629 23.54 32.71z",
  clipRule: "evenodd"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C2",
  fillRule: "evenodd",
  d: "M174.085 131.393l1.844-1.629L85.214 91.57l1.278 1.715 87.593 38.108z",
  clipRule: "evenodd"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "#5B534D",
  fillRule: "evenodd",
  d: "M297.051 218.083l-.026-.617-.27.083.032.618c-3.719 1.263-4.015 5.721-4.015 5.721s1.897-1.118 2.636-.139c0 0 .671-.68 1.58-1.061l.222 4.813s.058.755.026.958c-.047.318-.322.291-.364.028-.032-.22-.196-.177-.222.009-.027.186.158.616.528.448.37-.168.343-.528.343-.528l-.047-.999-.217-4.829c.55-.181 1.162-.232 1.77.032 0 0 1.543-1.744 2.541-1.267 0 0-.507-4.42-4.517-3.27z",
  clipRule: "evenodd"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#5B534D",
  fillRule: "evenodd",
  d: "M300.231 228.566l-5.51 1.721c-1.521.475-2.821-.541-2.895-2.263l-.285-6.251c-.079-1.723 1.094-3.509 2.615-3.984l5.51-1.721c1.521-.475 2.821.541 2.9 2.263l.28 6.252c.079 1.722-1.093 3.509-2.615 3.983zm3.312-10.541c-.105-2.335-1.864-3.711-3.925-3.068l-5.515 1.721c-2.06.644-3.645 3.066-3.539 5.4l.28 6.252c.105 2.335 1.865 3.712 3.925 3.068l5.515-1.721c2.06-.643 3.65-3.066 3.545-5.4l-.286-6.252zM296.998 198.982l-.015.005-.201.062.528 1.406.444-.421.592 2.24-.782-1.66-.36.348-.755-1.811-.977.301s-1.089 3.089-.687 4.723c.349 1.413 1.933.955 2.356.805l.153 3.799c-.607.227-1.268.686-1.648.97-.069.051-.042.161.032.139l3.55-1.091c.074-.023.09-.143.021-.153-.386-.057-1.083-.115-1.712.056l-.153-3.793c.481-.133 1.965-.665 2.182-2.199.259-1.838-1.051-4.19-1.051-4.19l-1.517.464z",
  clipRule: "evenodd"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "#5B534D",
  fillRule: "evenodd",
  d: "M302.836 205.347c.068 1.724-1.11 3.506-2.626 3.973l-5.515 1.694c-1.521.467-2.81-.556-2.884-2.281l-.259-6.259c-.069-1.724 1.109-3.507 2.625-3.973l5.516-1.694c1.521-.467 2.815.556 2.884 2.28l.259 6.26zm-3.191-9.653l-5.51 1.694c-2.06.633-3.661 3.049-3.56 5.387l.253 6.259c.1 2.338 1.854 3.725 3.915 3.092l5.515-1.693c2.055-.633 3.655-3.049 3.56-5.387l-.259-6.26c-.1-2.337-1.854-3.724-3.914-3.092z",
  clipRule: "evenodd"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M276.015 167.304l-40.914 13.33.211 8.16 40.915-13.33-.212-8.16z",
  clipRule: "evenodd"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fill: "#474646",
  fillRule: "evenodd",
  d: "M238.043 180.824l-.856.279.153 5.856.856-.279-.153-5.856zM241.408 179.727l-1.97.642.153 5.857 1.97-.642-.153-5.857zM243.284 179.117l-.751.244.154 5.857.75-.245-.153-5.856zM245.302 178.46l-.798.26.148 5.856.798-.26-.148-5.856zM249.47 177.1l-2.531.825.153 5.857 2.531-.825-.153-5.857zM251.535 176.428l-.565.183.153 5.857.565-.184-.153-5.856zM255.846 175.023l-3.376 1.1.153 5.856 3.376-1.1-.153-5.856zM257.721 174.411l-.84.276.148 5.856.845-.275-.153-5.857zM261.287 173.251l-1.69.55.153 5.856 1.685-.549-.148-5.857zM263.136 172.649l-.914.296.153 5.857.909-.296-.148-5.857zM267.473 171.235l-1.215.397.148 5.856 1.22-.397-.153-5.856zM268.709 170.833l-.486.157.154 5.857.486-.158-.154-5.856zM272.069 169.738l-1.875.611.153 5.857 1.875-.612-.153-5.856zM274.04 169.096l-.655.214.147 5.857.656-.214-.148-5.857z",
  clipRule: "evenodd"
});

var _ref19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f",
  width: 341,
  height: 242.5,
  x: 39,
  y: 151,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur",
  stdDeviation: 29.5
})));

function SvgBoxShadow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 400,
    fill: "none",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxShadow);
export default __webpack_public_path__ + "static/media/boxShadow.0f6cd5ce.svg";
export { ForwardRef as ReactComponent };